import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IOrderDelivery, ORDER_LINE_STATES } from '@cakeiteasy/web-utils';
import { CART_DELIVERY_TYPES, DELIVERY_ORDER_DELIVERY_TYPES } from '../../../cart/constants/common';

@Component({
  standalone: false,
  selector: 'order-info-delivery',
  templateUrl: './order-info-delivery.component.html'
})
export class OrderInfoDeliveryComponent {
  @Input() deliveryOrder: IOrderDelivery;
  @Input() showDeliveryEdit = false;
  @Output() onDeliveryEdit = new EventEmitter<void>();

  public ORDER_LINE_STATES = ORDER_LINE_STATES;

  public get headerTranslateKey() {
    if (this.deliveryOrder
      && this.deliveryOrder.type === CART_DELIVERY_TYPES.DELIVERY
      && this.deliveryOrder.deliveryType === DELIVERY_ORDER_DELIVERY_TYPES.MAIL) {
      return 'common.delivery.mailDelivery';
    }

    return 'common.delivery.deliveryToDoor';
  }
}
